export * from './herausgebers-filter.component';
export * from './herausgebers-filter.component.module';